/* eslint-disable max-len */
import AppHeader from '../../components/AppHeader';
import FileInput from '../../components/FileInput';
import Loader from '../../components/Loader';
import MyModal from '../../components/Modal';
import NoData from '../../components/NoData';
import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import DisplayEmployeesMap from './components/DisplayEmployeesMap';
import DisplayLtsMap from './components/DisplayLtsMap';
import EmployeesList from './components/EmployeesList';
import WorkplaceList from './components/WorkplaceList';

import OpacityAnimation from '../../components/OpacityAnimation';
import useGetGeneralAppData from '../../hooks/useGetGeneralAppData';
import CsvSubmit from './components/CsvSubmit';
import DataFilters from './components/DataFilters';
import DataHeader from './components/DataHeader';
import DownloadGeneralCsv from './components/DownloadGeneralCsv';
import RoleAndSindFilter from './components/RoleAndSindFilter';
import { Header } from './styles';
import useTriangulation from './useTriangulation';

export default function Triangulation() {
  const {
    isLoading,
    visualizationKind,
    isModalVisible,
    rolesList,
    isRolesSelectDisabled,
    sindList,
    employeesList,
    selectedEmployee,
    currentWorkplaceList,
    selectedCurrentWorkplace,
    destinyWorkplaceList,
    selectedDestinyWorkplace,
    apiFetched,
    csvFileName,
    dataByCurrentWorkplace,
    dataByDestinyWorkplace,
    dataByEmployee,
    rawData,
    dataView,
    downloadExampleFileRef,
    handleFileUpload,
    handleSubmitFile,
    handleRoleChange,
    handleSindChange,
    handleCurrentWorkplaceChange,
    handleDestinyWorkplaceChange,
    handleEmployeeChange,
    userProfile,
    companyCode,
    dataList,
    selectedRole,
    selectedSind,
    setIsModalVisible,
    setVisualizationKind,
    setSelectedDestinyWorkplace,
    setSelectedEmployee,
    setDataView,
    setSelectedCurrentWorkplace,
    getTriangulationData,
  } = useTriangulation();

  const isCaptaUser = (userProfile !== 10 && userProfile !== 11 && userProfile !== 12);
  const isCompanySelected = !!companyCode;
  // eslint-disable-next-line max-len
  const doesListExists = employeesList.length > 0 && destinyWorkplaceList.length > 0 && currentWorkplaceList.length > 0 && apiFetched && dataList.length > 0 && !isLoading;
  const isSomethingSelected = (selectedEmployee.value || selectedDestinyWorkplace.value || selectedCurrentWorkplace.value);
  const { permissions } = useGetGeneralAppData();
  const triangulationPermissions = permissions.find((x) => x.codPag === 13);

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Triangulation" />
      <Transitions>
        <Loader isLoading={isLoading} />
        {isCompanySelected && (
          <OpacityAnimation delay={0.5}>
            <Header>
              {doesListExists && (
                <RoleAndSindFilter
                  selectedRole={selectedRole}
                  handleRoleChange={handleRoleChange}
                  isLoading={isLoading}
                  isRolesSelectDisabled={isRolesSelectDisabled}
                  rolesList={rolesList}
                  selectedSind={selectedSind}
                  handleSindChange={handleSindChange}
                  sindList={sindList}
                />
              )}
              {(isCaptaUser && triangulationPermissions?.incluir) && (
                <CsvSubmit
                  downloadExampleFileRef={downloadExampleFileRef}
                  setIsModalVisible={setIsModalVisible}
                />
              )}
              {(doesListExists && triangulationPermissions?.imprimir) && (
                <DownloadGeneralCsv dataList={dataList} />
              )}
            </Header>

            {doesListExists && (
              <OpacityAnimation delay={0.1}>
                <DataFilters
                  setSelectedDestinyWorkplace={setSelectedDestinyWorkplace}
                  setSelectedEmployee={setSelectedEmployee}
                  setVisualizationKind={setVisualizationKind}
                  visualizationKind={visualizationKind}
                  setSelectedCurrentWorkplace={setSelectedCurrentWorkplace}
                  selectedCurrentWorkplace={selectedCurrentWorkplace}
                  currentWorkplaceList={currentWorkplaceList}
                  handleCurrentWorkplaceChange={handleCurrentWorkplaceChange}
                  isLoading={isLoading}
                  selectedDestinyWorkplace={selectedDestinyWorkplace}
                  destinyWorkplaceList={destinyWorkplaceList}
                  handleDestinyWorkplaceChange={handleDestinyWorkplaceChange}
                  selectedEmployee={selectedEmployee}
                  employeesList={employeesList}
                  handleEmployeeChange={handleEmployeeChange}
                />

                {!!isSomethingSelected && (
                  <DataHeader
                    setDataView={setDataView}
                    dataView={dataView}
                    selectedEmployee={selectedEmployee}
                    selectedDestinyWorkplace={selectedDestinyWorkplace}
                    selectedCurrentWorkplace={selectedCurrentWorkplace}
                    rawData={rawData}
                  />
                )}

                {visualizationKind === 'cwp' && (
                  <>
                    {!!selectedCurrentWorkplace.value && (
                      dataView === 'map'
                        ? (
                          dataByCurrentWorkplace.length > 0 && (
                            <DisplayEmployeesMap data={dataByCurrentWorkplace} />
                          )
                        )
                        : (
                          dataByCurrentWorkplace.length > 0 && (
                            <EmployeesList
                              list={dataByCurrentWorkplace}
                            />
                          )
                        )
                    )}

                    {dataByCurrentWorkplace.length === 0 && !!selectedCurrentWorkplace.value && (
                      <NoData
                        icon="emptyBox"
                        label={(
                          <>
                          Não foi encontrado nenhum resultado conforme os filtros selecionados.
                          </>
                        )}
                      />
                    )}

                    {!selectedCurrentWorkplace.value && (
                      <NoData
                        icon="emptyBox"
                        label={(
                          <>
                            Selecione um local de trabalho origem para visualizar os dados.
                          </>
                        )}
                      />
                    )}
                  </>
                )}

                {visualizationKind === 'dwp' && (
                  <>
                    {!!selectedDestinyWorkplace.value && (
                      dataView === 'map'
                        ? (
                          dataByDestinyWorkplace.length > 0 && (
                            <DisplayEmployeesMap data={dataByDestinyWorkplace} />
                          )
                        )
                        : (
                          dataByDestinyWorkplace.length > 0 && (
                            <EmployeesList
                              list={dataByDestinyWorkplace}
                            />
                          )
                        )
                    )}

                    {!!selectedDestinyWorkplace.value && dataByDestinyWorkplace.length === 0 && (
                      <NoData
                        icon="emptyBox"
                        label={(
                          <>
                          Não foi encontrado nenhum resultado conforme os filtros selecionados.
                          </>
                        )}
                      />
                    )}

                    {!selectedDestinyWorkplace.value && (
                      <NoData
                        icon="emptyBox"
                        label={(
                          <>
                        Selecione um local de trabalho destino para visualizar os dados.
                          </>
                        )}
                      />
                    )}
                  </>
                )}

                {visualizationKind === 'employees' && (
                  <>
                    {!!selectedEmployee.value && (
                      dataView === 'map'
                        ? (
                          dataByEmployee.length > 0 && (
                            <DisplayLtsMap data={dataByEmployee} />
                          )
                        )
                        : (
                          dataByEmployee.length > 0 && (
                            <WorkplaceList
                              list={dataByEmployee}
                            />
                          )
                        )
                    )}

                    {!!selectedEmployee.value && dataByEmployee.length === 0 && (
                      <NoData
                        icon="emptyBox"
                        label={(
                          <>
                          Não foi encontrado nenhum resultado conforme os filtros selecionados.
                          </>
                        )}
                      />
                    )}

                    {!selectedEmployee.value && (
                      <NoData
                        icon="emptyBox"
                        label={(
                          <>
                        Selecione um funcionário para visualizar os dados.
                          </>
                        )}
                      />
                    )}
                  </>
                )}
              </OpacityAnimation>
            )}

            {!doesListExists && (
              <NoData
                icon="emptyBox"
                label={(
                  <>
                    Esta empresa não tem dados importados de triangulação.
                    {' '}
                    {isCaptaUser ? (
                      <>
                        Clique no botão
                        {' '}
                        <strong>Importar arquivo</strong>
                        {' '}
                        acima para importar um arquivo!
                      </>
                    ) : (
                      'Entre em contato conosco para solicitar seus dados de triangulação'
                    )}
                  </>
                )}
              />
            )}

            {!apiFetched && (
              <NoData
                icon="sad"
                label={(
                  <>
                    Ocorreu um erro ao obter os dados de triangulação.
                    <button type="button" onClick={() => { getTriangulationData(); }}>Tentar Novamente</button>
                  </>
                )}
              />
            )}
          </OpacityAnimation>
        )}

        <MyModal
          show={isModalVisible}
          title="Importar dados por CSV"
          centeredBody
          modalBody={(
            <FileInput
              buttonLabel="Importar arquivo"
              fileNameChoosed={csvFileName}
              isSubmitButtonDisabled={!csvFileName}
              onFileUpload={handleFileUpload}
              onSubmitFile={handleSubmitFile}
              acceptedFiles=".csv"
            />
          )}
          closeButtonLabel="Fechar"
          onClose={() => setIsModalVisible(false)}
          type="info"
        />

        {!isCompanySelected && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
              Selecione uma empresa para visualizar os dados de sua triangulação.
              </>
            )}
          />
        )}
      </Transitions>
    </>
  );
}
